import Psfs from 'lib/psfs/Psfs'
import BaseSearchBlock from 'components/common/Table/DataTable/SearchBlock'

class SearchBlock extends BaseSearchBlock {
  constructor(props) {
    super(props)
    this.searchTimer = null
    this.state = {
      searchValue: '',
    }
  }

  onSearchChange = e => {
    const { storePsfs, setPsfs } = this.props

    clearTimeout(this.searchTimer)
    this.setState({ searchValue: e.target.value }, () => {
      this.searchTimer = setTimeout(() => {
        const psfs = new Psfs(storePsfs.path)
        psfs.paginationObj.clearPagination()
        psfs.addSearch(this.state.searchValue)
        setPsfs(psfs)
      }, 2000)
    })
  }

  onSearchEnterDown = e => {
    if (e.keyCode === 13) {
      const { storePsfs, setPsfs } = this.props

      clearTimeout(this.searchTimer)
      const psfs = new Psfs(storePsfs.path)
      psfs.paginationObj.clearPagination()
      psfs.addSearch(this.state.searchValue)
      setPsfs(psfs)
    }
  }

  onClear = () => {
    const { storePsfs, setPsfs } = this.props

    if (this.state.searchValue) {
      this.setState({ searchValue: '' })
      clearTimeout(this.searchTimer)
      const psfs = new Psfs(storePsfs.path)
      psfs.paginationObj.clearPagination()
      psfs.searchObj.clearSearch()
      setPsfs(psfs)
    }
  }
}

export default SearchBlock
